import { render, staticRenderFns } from "./WorkDetail1.vue?vue&type=template&id=06d03864&scoped=true&"
import script from "./WorkDetail1.vue?vue&type=script&lang=js&"
export * from "./WorkDetail1.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail1.vue?vue&type=style&index=0&id=06d03864&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d03864",
  null
  
)

export default component.exports